import { DropdownSelect } from "../../ui/dropdown-select";

interface YearSelectProps {
  label: string;
  value: number;
  options: { name: string | number; value: string | number }[];
  onChange: (value: string) => void;
}

export function YearSelect({ label, value, options, onChange }: YearSelectProps) {
  const dropdownOptions = (options || []).map((opt) => ({
    value: String(opt.value),
    label: String(opt.name),
  }));

  return (
    <div className="tw:grid tw:gap-2">
      <label className="tw:text-sm tw:font-medium tw:leading-none tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-70">
        {label}
      </label>
      <DropdownSelect
        value={String(value)}
        onValueChange={onChange}
        options={dropdownOptions}
        placeholder="Select a year"
        triggerClassName="tw:w-[180px]"
      />
    </div>
  );
}
